import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { compose, lifecycle, renderNothing, branch } from 'recompose'

import * as UserActions from 'modules/user/actions'
import * as ExperimentSelectors from 'modules/experiment/selectors'
import * as OrgSelectors from 'modules/org/selectors'
import * as OrgActions from 'modules/org/actions'

import Setup from './component'

const mapStateToProps = state => ({
  color: OrgSelectors.getColor(state),
  orgId: OrgSelectors.getOrgId(state),
  loaded: ExperimentSelectors.getLoaded(state),
  finishOnboardingNotification: OrgSelectors.getFinishOnboardingNotification(state),
  properties: OrgSelectors.getOrgProperties(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchUser: UserActions.fetchUser,
    fetchEmbed: OrgActions.fetchEmbed,
    setIsCalendarOnboarding: UserActions.setIsCalendarSeatOnboarding,
  }, dispatch)
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      if (!this.props.orgId && this.props.location.pathname.includes('touchless')) {
        this.props.actions.fetchUser()
        this.props.actions.fetchEmbed()
      }
      this.props.actions.setIsCalendarOnboarding(this.props.location.pathname.includes('calendaring'))
    }
  }),
  branch(props => {
    if (props.location.pathname.includes('start')) {
      return false
    } else if (props.location.pathname.includes('touchless') && !props.loaded) {
      return true
    } else {
      return false
    }
  }, renderNothing)
)(Setup)



// WEBPACK FOOTER //
// ./src/layouts/Setup/index.js